export enum FileParseUploadStatusTypeEnum {
    Uploaded = 0,
    InQueue = 1,
    NeedsReview = 2,
    Processing = 3,
    Complete = 4,
    Failed = 5,
    TimedOutWhileCompletingUpload = 6,
    Created = 7,
    Uploading = 8,
    NeedsResubmission = 9,
    TimedOutDuringUpload = 10
}

export enum FileParseUploadStatusTypeEnumString {
    Uploaded = 'Uploaded',
    InQueue = 'In Queue',
    NeedsReview = 'Needs Review',
    Processing = 'Processing',
    Complete = 'Complete',
    Failed = 'Failed',
    TimedOutWhileCompletingUpload = 'Timed Out While Completing Upload',
    Created = 'Created',
    Uploading = 'Uploading',
    
    NeedsResubmission = 'Needs Resubmission',
    TimedOutDuringUpload = 'Timed Out During Upload'
}